/**
 * The tenant code of a hostname: its first segment, without the suffix of the environment
 * ("ufc-dev.foris.app" with environment "dev" → "ufc").
 */
export const toTenantCode = (
  hostname: string | null | undefined,
  environment?: string | null,
): string => {
  const [segment = ""] = (hostname ?? "").split(".");
  const suffix = environment ? `-${environment}` : null;

  return suffix && segment.endsWith(suffix) ? segment.slice(0, -suffix.length) : segment;
};

/** The tenant codes of a comma-separated list, trimmed and lowercased, without empty entries. */
export const parseTenantList = (value: string | null | undefined): string[] =>
  (value ?? "")
    .split(",")
    .map(code => code.trim().toLowerCase())
    .filter(Boolean);
